import { Icons } from '@Assets/SvgIcons';
import React, { useEffect, useRef, useState } from 'react';
import css from '../AiModal.module.css';
import AiMessageInput from '../AiMessageInput';
import axios from 'axios';
import { AiQueryResponse } from '@Helper/Interfaces';
import { Avatar } from '@mui/material';
import { useAppSelector } from '@Store/hooks';
import { getUserInfo } from '@Store/feature/directory';
import { MergefloColors } from '@Helper/MergefloColors';
import { TabProps } from '../AiModal';

export interface MessageHolder {
  from: 'user' | 'ai';
  message: string;
  type: 'hasFile' | 'message';
  icon?: any;
}

const GeneralTab = ({
  initialMessageHolder,
  currentConversationId,
  setMainConversationId,
  setMainMessageHolder,
  historyMode,
}: TabProps) => {
  const [currentMessageHolder, setCurrentMessageHolder] =
    useState<MessageHolder[]>(initialMessageHolder);
  console.log('initialMessageHolder ', initialMessageHolder);

  const userInfo = useAppSelector(getUserInfo);
  const messageRef = React.useRef<HTMLDivElement>(null);
  const generateAvatar = () => {
    let response = '';
    if (userInfo?.name?.length && userInfo?.name?.length > 0)
      response = userInfo?.name[0];
    if (userInfo?.surname?.length && userInfo?.surname?.length > 0)
      response = response + userInfo?.surname[0];
    return response.length === 0 ? 'NO' : response.toUpperCase();
  };
  const mergefloColors = new MergefloColors();

  const [conversationId, setConversationId] = useState<string>(
    currentConversationId
  );

  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
  }, [currentMessageHolder]);

  useEffect(() => {
    if (setMainConversationId && conversationId !== '') {
      setMainConversationId(conversationId);
    }
    if (setMainMessageHolder && currentMessageHolder.length > 0) {
      console.log('here');

      setMainMessageHolder(currentMessageHolder);
    }
  }, [currentMessageHolder, conversationId]);

  const onConversation = (e: string) => {
    const messageHolderQuery = [...currentMessageHolder];
    messageHolderQuery.push({
      from: 'user',
      message: e,
      type: 'message',
    });
    messageHolderQuery.push({
      from: 'ai',
      message: '...',
      type: 'message',
    });
    setCurrentMessageHolder([...messageHolderQuery]);

    let headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('userToken'),
    };
    let body = {
      aiQueryType: 'generalchat',
      prompt: e,
    };
    if (conversationId !== '') {
      (body as any).conversationId = conversationId;
    }
    axios
      .post(
        (process.env.REACT_APP_MERGEFLO_API_URL ?? '') + '/api/v1/aiquery',
        body,
        {
          headers: headers,
        }
      )
      .then(res => {
        const queryResponse = res.data as AiQueryResponse;
        console.log('res', res);
        let newMessageHolder = [...messageHolderQuery];
        newMessageHolder = newMessageHolder.filter(i => i.message !== '...');
        window.setTimeout(function () {}, 2000);
        newMessageHolder.push({
          from: 'ai',
          message: queryResponse.result,
          type: 'message',
        });
        setConversationId(queryResponse.conversationId);
        setCurrentMessageHolder([...newMessageHolder]);
        window.setTimeout(function () {}, 2000);
      })
      .catch(err => {
        let newMessageHolder = [...messageHolderQuery];
        newMessageHolder = newMessageHolder.filter(i => i.message !== '...');
        newMessageHolder.push({
          from: 'ai',
          type: 'message',
          message:
            'I encountered with some errors on query. Please contact with mergeflo.com for this situation',
        });
        setCurrentMessageHolder([...newMessageHolder]);
        window.setTimeout(function () {}, 2000);
      });
  };

  return (
    <React.Fragment>
      <div
        className={[css.aiModalTabContent, ' customScroll'].join(' ')}
        id="message"
      >
        {currentMessageHolder.length === 0 && (
          <div className={css.EmptyMessage}>
            <Icons.EmptyMessage />
            <span>Type your query here to get a response from Mergeflo AI</span>
          </div>
        )}
        {currentMessageHolder.length > 0 && (
          <div className={css.messageContent}>
            {currentMessageHolder.map((message, index) => (
              <div
                key={index}
                className={[css.messageContent, ' customScroll'].join(' ')}
                ref={messageRef}
              >
                {message.from === 'user' ? (
                  <div className={css.userMessageContent}>
                    <div className={css.messageUser}>{message.message}</div>
                    <Avatar
                      className={css.userAvatar}
                      style={{
                        backgroundColor: mergefloColors.getUserColors(
                          userInfo?.name ?? 'N'
                        ),
                        fontSize: 15,
                        fontWeight: 'bold',
                      }}
                    >
                      {generateAvatar()}
                    </Avatar>
                  </div>
                ) : (
                  <div className={css.aiMessageContent}>
                    <Avatar className={css.aiAvatar}>
                      <Icons.Undo />
                    </Avatar>
                    <div className={css.messageAi}>{message.message}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      <AiMessageInput
        placeholder="Type your query here to get a response from Mergeflo AI"
        onConversation={onConversation}
      />
    </React.Fragment>
  );
};

export default GeneralTab;
